module.exports = __webpack_public_path__ + "static/img/icon_app_14.371ef2d9.png";